import { EnumClientDisplayPattern } from '../../constant'

export const mixinJleagueClient = {
    data() {
        return {
            clientId: null,
        }
    },
    computed: {
        /**
         * clientId からクライアント情報を返す
         * @returns {{display_pattern: string, display_agreement_check: boolean, login_button_pattern: string, display_header_footer: boolean, client_id: string}|{display_pattern: string, display_agreement_check: boolean, login_button_pattern: string, display_header_footer: boolean, client_id: string}|{display_pattern: string, display_agreement_check: boolean, login_button_pattern: string, display_header_footer: boolean, client_id: string, redirect_url: string}|null}
         */
        jleagueClient() {
            if (typeof jleagueClientList === 'undefined' || !this.clientId) return null
            const client = jleagueClientList.getClient(this.clientId)

            return !!client? client: null
        },

        /**
         * ヘッダー・フッターを表示するか?
         * @returns {boolean}
         */
        isDisplayHeaderFooter() {
            return !this.jleagueClient || !!this.jleagueClient?.display_header_footer
        },

        /**
         * 利用規約チェックを表示するか?
         * @returns {boolean}
         */
        isDisplayAgreementCheck() {
            return !this.jleagueClient || !!this.jleagueClient?.display_agreement_check
        },

        /**
         * 会員情報入力画面の表示パターン (サインアップ・会員情報更新)
         * @returns {string|null}
         */
        displayPattern() {
            return (!!this.jleagueClient?.display_pattern)? this.jleagueClient.display_pattern: EnumClientDisplayPattern.Full;
        },

        /**
         * ログインボタンのパターン (未使用?)
         * @returns {string|null}
         */
        loginButtonPattern() {
            return  (!!this.jleagueClient?.login_button_pattern)? this.jleagueClient.login_button_pattern: null
        },

        /**
         * リダイレクトURLを返す
         * @returns {string}
         */
        redirectUrl() {
            return (!!this.jleagueClient?.redirect_url)? this.jleagueClient.redirect_url: ''
        },
    },
    created() {
        this.setClientId()
    },
    methods: {
        /**
         * thymeleaf のセッション変数からクライアントIDを取得してプロパティに設定する
         * FLPのときは mixin のメソッドで setClientId しない
         */
        setClientId() {
            const element = document.getElementById('xDataClientId')
            if (!element) return

            const clientId = element.innerText.trim()
            if (!!clientId) this.clientId = clientId
        },
    },
}
